import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';
import {
    CTAType,
    TrackingLabelLookupType
} from './ListingMoreInformation.types';

const trackingEvent: TrackingLabelLookupType = {
    floorplans: { trackingLabel: 'floorplan tab' },
    tours: { trackingLabel: 'virtualtours tab' },
    energy: { trackingLabel: 'EPC link' },
    additional_links: { trackingLabel: 'additional links' },
    listing_history: { trackingLabel: 'listing history' },
    smart_viewing: { trackingLabel: 'smart viewing' },
    streetview: { trackingLabel: 'streetview' },
    report_listing: { trackingLabel: 'report listing' },
    market_stats: { trackingLabel: 'market stats tab' }
};

export const trackMoreInformationCTAClick = (event: CTAType) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'open tab',
        eventLabel: trackingEvent[event].trackingLabel
    });
};

export const trackMoreInformationClickThrough = (event: CTAType) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: trackingEvent[event].trackingLabel
    });
};
